// extracted by mini-css-extract-plugin
export default {"wrapper":"CB-z","viewport":"DB-z","container":"EB-z","slide":"FB-z"};